/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Main,
  BoxSelect,
  BoxItems,
  InputFind,
  Options,
  Items,
  SubItems,
  CheckboxInput,
  IconItem,
  BoxItemsSelected,
  BoxSearch,
  ItemList,
  ErrorMessage,
  Text,
  Row,
  RadioInput,
  LinkItem,
} from './style';

const Categorizing = (props) => {
  const {
    category,
    error,
    limit,
    showEasySelect,
    isRadioBtn,
    values,
    callbackCatAndSubCat,
  } = props;

  const [hideItems, setHideItems] = useState([]);
  const [filter, setFilter] = useState('');
  const [selectedItem, setSelectedItem] = useState([]);
  const [limitError, setLimitError] = useState(null);

  const getHideItemsArray = useCallback(() => {
    const hideItemsArray = [...hideItems];
    const selectedCategories = selectedItem.map((item) => item.parent_id);

    Object.keys(category).map(
      (index) => hideItemsArray.push({
        id: category[index].values.id,
        status: selectedCategories.includes(category[index].values.id),
      }),
    );

    return hideItemsArray;
  }, [category, hideItems, selectedItem]);

  useEffect(() => {
    if (!_.isEmpty(values)) {
      setSelectedItem(values);
    }
  }, [values]);

  useEffect(() => {
    callbackCatAndSubCat(selectedItem, props.type);
    if (selectedItem.length > 0) {
      const hideItemsArray = getHideItemsArray();
      setHideItems(hideItemsArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  const hideItem = useCallback((key, value) => {
    const hideItemsArray = getHideItemsArray();
    const check = value;

    const obj = hideItemsArray.findIndex((o) => o.id === key);
    hideItemsArray[obj].status = (check !== null ? check : !hideItemsArray[obj].status);
    setHideItems(hideItemsArray);
  }, [getHideItemsArray]);

  const selectedItemCate = useCallback((key) => {
    const arraySelected = [...selectedItem];
    const index = arraySelected.findIndex((v) => v.id === key);
    const auxLimit = isRadioBtn ? 1 : limit;

    if (index !== -1) {
      arraySelected.splice(index, 1);
    } else if (isRadioBtn) {
      arraySelected[0] = { id: key };
    } else if (!auxLimit || selectedItem.length < auxLimit) {
      arraySelected.push({ id: key });
    } else {
      setLimitError(`You cannot select more than ${limit} items.`);
      const timerId = setTimeout(() => {
        setLimitError(null);
        clearTimeout(timerId);
      }, 3000);
    }

    setSelectedItem([...arraySelected]);
  }, [limit, selectedItem]);

  const filterFront = useCallback((value, categoryKey) => {
    Object.keys(categoryKey)
      .map((indexCat) => {
        if (value.length >= 3) {
          return (hideItem(categoryKey[indexCat].values.id, true));
        }
        return (hideItem(categoryKey[indexCat].values.id, false));
      });
    setFilter(value);
  }, [hideItem, setFilter]);

  const clearInput = useCallback(() => {
    filterFront('', category);
  }, [filterFront, category]);

  const handleSelectAll = () => {
    const selected = category.reduce((previousValue, { sub }) => [
      ...previousValue,
      ...sub,
    ], []);

    setSelectedItem(selected);
  };

  const handleDeselectAll = () => {
    setSelectedItem([]);
    setHideItems([]);
  };

  const renderRadio = (indexCat, indexSubCat) => (
    <RadioInput
      name="radioGroup"
      label={category[indexCat].sub[indexSubCat].name}
      checked={
        selectedItem.findIndex(
          (v) => v.id === category[indexCat].sub[indexSubCat].id,
        ) !== -1
      }
      onChange={() => selectedItemCate(category[indexCat].sub[indexSubCat].id)}
      type="radio"
      value={category[indexCat].sub[indexSubCat].name}
    />
  );

  const renderCheckbox = (indexCat, indexSubCat) => (
    <>
      <CheckboxInput
        checked={
          selectedItem.findIndex(
            (v) => v.id === category[indexCat].sub[indexSubCat].id,
          ) !== -1
        }
        onChange={
          () => selectedItemCate(category[indexCat].sub[indexSubCat].id)
        }
        type="checkbox"
        value={category[indexCat].sub[indexSubCat].name}
      />

      <span onClick={
        () => selectedItemCate(category[indexCat].sub[indexSubCat].id)
      }
      >
        {category[indexCat].sub[indexSubCat].name}
      </span>
    </>
  );

  return (
    <Main>
      <BoxSelect>
        <BoxItems error={error || limitError}>
          <BoxSearch>
            <InputFind
              placeholder="Search"
              value={filter}
              onChange={(e) => filterFront(e.target.value, category)}
            />

            <Text>
              <span className="cancel" onClick={() => clearInput()}>
                Cancel
              </span>
            </Text>
          </BoxSearch>

          {showEasySelect && (
            <Row>
              <LinkItem onClick={handleSelectAll}>Select all</LinkItem>
              <LinkItem onClick={handleDeselectAll}>Deselect all</LinkItem>
            </Row>
          )}

          <ItemList>
            {Object.keys(category)
              .filter((indexCat) => category[indexCat].values.name
                .toUpperCase()
                .replace(/\s/g, '')
                .includes(filter.toUpperCase().replace(/\s/g, ''))
                || category[indexCat].sub
                  .find((x) => x.name
                    .replace(/\s/g, '')
                    .toUpperCase()
                    .includes(filter.toUpperCase().replace(/\s/g, ''))))
              .map((indexCat) => (
                <Options key={indexCat}>
                  <Items onClick={() => hideItem(category[indexCat].values.id, null)}>
                    {!hideItems[hideItems.findIndex((o) => o.id === category[indexCat].values.id)]
                      || !hideItems[hideItems.findIndex((o) => o.id === category[indexCat].values.id)].status ? '+' : '-'}
                    {' '}
                    {category[indexCat].values.name}
                  </Items>
                  {
                    (
                      hideItems[hideItems
                        .findIndex((o) => o.id === category[indexCat].values.id)]
                      && hideItems[hideItems
                        .findIndex((o) => o.id === category[indexCat].values.id)].status
                    )
                    && Object.keys(category[indexCat].sub)
                      .filter((indexSubCat) => category[indexCat].sub[indexSubCat].name
                        .toUpperCase()
                        .replace(/\s/g, '')
                        .includes(filter.toUpperCase().replace(/\s/g, '')))
                      .map((indexSubCat) => (
                        <SubItems key={indexSubCat}>
                          {(!isRadioBtn && renderCheckbox(indexCat, indexSubCat)) || renderRadio(indexCat, indexSubCat)}
                        </SubItems>
                      ))
                  }
                </Options>
              ))}
          </ItemList>
        </BoxItems>

        {(error || limitError) && (
          <ErrorMessage>
            <span>
              {error}
              {limitError}
            </span>
          </ErrorMessage>
        )}

        <BoxItemsSelected>
          <Text>Selected:</Text>
          <div className="item">
            {Object.keys(category)
              .map((indexCat) => (Object.keys(category[indexCat].sub)
                .filter(
                  (indexSubCat) => selectedItem.find(
                    (o) => o.id === category[indexCat].sub[indexSubCat].id,
                  ),
                )
                .map((indexSubCat) => (
                  <span key={indexSubCat}>
                    {category[indexCat].sub[indexSubCat].name}
                    <IconItem
                      name="close"
                      onClick={() => selectedItemCate(category[indexCat].sub[indexSubCat].id)}
                    />
                  </span>
                ))))}
          </div>
        </BoxItemsSelected>
      </BoxSelect>
    </Main>
  );
};

Categorizing.propTypes = {
  category: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({
      values: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
      sub: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      })),
    })),
    PropTypes.objectOf(PropTypes.shape({
      values: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
      sub: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      })),
    })),
  ]).isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  isRadioBtn: PropTypes.bool,
  limit: PropTypes.number,
  error: PropTypes.string,
  callbackCatAndSubCat: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  showEasySelect: PropTypes.bool,
};

Categorizing.defaultProps = {
  values: undefined,
  limit: undefined,
  error: undefined,
  showEasySelect: false,
  isRadioBtn: false,
};

export default Categorizing;
